import FullWidthStaticLayout from '@/Layout/FullWidthStaticLayout';

const TermsPage = () => {
  return (
    <FullWidthStaticLayout>
      <h1>Terms and Conditions</h1>
      <h2>ROKiT iD</h2>
      <h3>Operated by ROKiT Group</h3>

      <h2>1. Introduction</h2>
      <p>
        Welcome to <strong>ROKiT iD</strong>, an account registration, authentication, and single sign-on service
        operated by <strong>ROKiT Group</strong> ("ROKiT", "we", "our", or "us").
      </p>
      <p>
        ROKiT iD allows users to create and manage a single account that may be used to access ROKiT services,
        applications, websites, membership platforms, media platforms, communications products, and related services,
        including services that may operate under the <strong>Enigma</strong> or <strong>Riddle</strong> names.
      </p>
      <p>
        These Terms and Conditions ("Terms") govern your access to and use of ROKiT iD, including account creation,
        login, authentication, identity verification, profile management, security features, and related account
        services.
      </p>
      <p>
        By creating a ROKiT iD account, accessing ROKiT iD, or using ROKiT iD to sign in to a participating service,
        you agree to comply with these Terms.
      </p>
      <p>If you do not agree to these Terms, you must not use ROKiT iD.</p>

      <h2>2. Relationship with Other ROKiT Services</h2>
      <p>
        ROKiT iD is an account and access service. Other ROKiT products, websites, apps, platforms, memberships, or
        communications services may have their own additional terms, policies, community rules, payment terms, or
        acceptable use requirements.
      </p>
      <p>
        Where you use ROKiT iD to access another service, you must also comply with the terms applicable to that
        service. If there is a conflict between these Terms and the terms of a specific ROKiT service, the
        service-specific terms will apply to that service, while these Terms will continue to apply to your ROKiT iD
        account.
      </p>

      <h2>3. Eligibility</h2>
      <p>You must be at least:</p>
      <ul>
        <li>13 years old; or</li>
        <li>the minimum digital consent age in your country,</li>
      </ul>
      <p>whichever is higher.</p>
      <p>By using ROKiT ID, you confirm that:</p>
      <ul>
        <li>you meet the required age;</li>
        <li>you have the legal capacity to enter into these Terms;</li>
        <li>all information you provide is accurate and not misleading; and</li>
        <li>you will keep your account information up to date.</li>
      </ul>

      <h2>4. Account Registration</h2>
      <p>
        To use ROKiT iD, you may be required to provide registration information such as your name, username, email
        address, telephone number, password, and other account details.
      </p>
      <p>
        By creating a ROKiT iD account and providing your mobile number, you agree and consent to receive SMS messages from ROKiT for authentication, account verification, and security purposes (including one-time passwords).
      </p>
      <p>You agree to:</p>
      <ul>
        <li>provide accurate information;</li>
        <li>maintain the security of your credentials;</li>
        <li>keep passwords, PINs, verification codes, and authentication methods confidential;</li>
        <li>not share your account with unauthorised persons; and</li>
        <li>notify us immediately if you believe your account has been accessed without permission.</li>
      </ul>
      <p>You are responsible for all activity conducted through your ROKiT iD account.</p>

      <h2>5. Authentication and Security</h2>
      <p>
        ROKiT iD may provide features such as password login, email verification, telephone verification, one-time
        passcodes, multi-factor authentication, account recovery, session management, device recognition, and security
        alerts.
      </p>
      <p>
        You agree not to bypass, interfere with, disable, reverse engineer, or misuse any authentication, security,
        identity, or account protection feature.
      </p>
      <p>
        Although we use security measures designed to protect accounts, we cannot guarantee that unauthorised access,
        system compromise, service interruption, or data loss will never occur.
      </p>

      <h2>6. Acceptable Use</h2>
      <p>You agree not to use ROKiT iD to:</p>
      <ul>
        <li>violate any applicable law or regulation;</li>
        <li>create accounts using false, stolen, misleading, or unauthorised information;</li>
        <li>impersonate another person or organisation;</li>
        <li>gain unauthorised access to any account, system, service, or data;</li>
        <li>attempt credential stuffing, brute-force attacks, phishing, social engineering, or fraud;</li>
        <li>distribute malware, spyware, malicious code, or harmful links;</li>
        <li>interfere with the operation, security, or availability of ROKiT ID or any connected service;</li>
        <li>scrape, harvest, sell, or misuse account data;</li>
        <li>send spam, abusive traffic, or automated account creation requests;</li>
        <li>use ROKiT ID to facilitate harassment, exploitation, unlawful content, fraud, or other abusive behaviour.</li>
      </ul>

      <h2>7. Connected Services and SSO Access</h2>
      <p>
        ROKiT iD may be used to sign in to multiple ROKiT-operated or ROKiT-approved services. When you sign in to a
        connected service using ROKiT iD, certain account information may be shared with that service to enable login,
        account linking, profile display, entitlement checks, subscription access, security, and support.
      </p>
      <p>
        Connected services may include entertainment platforms, membership services, creator services, communications
        applications, websites, apps, and future ROKiT products.
      </p>

      <h2>8. Account Suspension and Termination</h2>
      <p>ROKiT Group may suspend, restrict, or terminate your ROKiT iD account if we reasonably believe that:</p>
      <ul>
        <li>you have violated these Terms;</li>
        <li>your account has been compromised;</li>
        <li>your account is being used for fraud, abuse, security attacks, or unlawful activity;</li>
        <li>continued access may harm users, ROKiT, connected services, or third parties;</li>
        <li>we are required to do so by law, regulation, court order, or legal process.</li>
      </ul>
      <p>Suspension or termination of your ROKiT iD account may affect your ability to access connected services.</p>

      <h2>9. User Content and Service Content</h2>
      <p>
        ROKiT iD is primarily an identity, registration, and access service. It may allow you to submit limited account
        content such as profile names, profile images, account preferences, support requests, and verification
        information.
      </p>
      <p>
        You retain ownership of content you submit, but you grant ROKiT Group a limited, worldwide, non-exclusive
        licence to host, store, process, transmit, and display that content solely for the purpose of operating,
        securing, supporting, and improving ROKiT iD and connected services.
      </p>

      <h2>10. Intellectual Property</h2>
      <p>
        ROKiT iD, including its software, branding, interfaces, security systems, logos, features, and related
        intellectual property, is owned by or licensed to ROKiT Group.
      </p>
      <p>You may not:</p>
      <ul>
        <li>copy;</li>
        <li>modify;</li>
        <li>distribute;</li>
        <li>sell;</li>
        <li>lease;</li>
        <li>decompile;</li>
        <li>reverse engineer; or</li>
        <li>commercially exploit</li>
      </ul>
      <p>any part of ROKiT iD without prior written permission.</p>
      <p>
        "ROKiT", "ROKiT iD", "Enigma", "Riddle", and associated branding may be trademarks or pending trademarks of
        ROKiT Group or its affiliates.
      </p>

      <h2>11. Privacy</h2>
      <p>Your use of ROKiT iD is also governed by our Privacy Policy.</p>
      <p>
        By using ROKiT iD, you acknowledge that your information may be collected, processed, stored, and shared with
        connected services in accordance with applicable privacy laws and our policies.
      </p>

      <h2>12. Third-Party Services</h2>
      <p>ROKiT iD may integrate with or rely upon third-party providers, including:</p>
      <ul>
        <li>cloud hosting providers;</li>
        <li>identity, authentication, and security providers;</li>
        <li>payment processors;</li>
        <li>app stores;</li>
        <li>analytics services;</li>
        <li>email, SMS, and notification providers;</li>
        <li>customer support platforms.</li>
      </ul>
      <p>ROKiT Group is not responsible for the availability, content, or practices of third-party services.</p>

      <h2>13. Paid Services and Subscriptions</h2>
      <p>
        ROKiT iD itself may be free to use, but it may be used to access paid ROKiT services, subscriptions,
        memberships, premium features, or paid content.
      </p>
      <p>
        Where payment is required for a connected service, additional payment, subscription, cancellation, refund, and
        app store terms may apply.
      </p>

      <h2>14. Service Availability</h2>
      <p>ROKiT iD is provided on an "as is" and "as available" basis.</p>
      <p>We do not guarantee:</p>
      <ul>
        <li>uninterrupted operation;</li>
        <li>permanent availability;</li>
        <li>error-free performance;</li>
        <li>compatibility with all devices, services, or networks;</li>
        <li>that all connected services will remain available.</li>
      </ul>
      <p>We may modify, suspend, or discontinue features at any time.</p>

      <h2>15. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, ROKiT Group shall not be liable for:</p>
      <ul>
        <li>indirect or consequential losses;</li>
        <li>loss of profits, revenue, business, opportunity, goodwill, or data;</li>
        <li>reputational damage;</li>
        <li>business interruption;</li>
        <li>losses arising from account compromise, unauthorised access, user conduct, or third-party actions;</li>
        <li>losses arising from inability to access a connected service.</li>
      </ul>
      <p>Nothing in these Terms excludes liability that cannot legally be excluded under applicable law.</p>

      <h2>16. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless ROKiT Group and its affiliates, directors, employees, and partners
        from claims, damages, liabilities, and expenses arising from:
      </p>
      <ul>
        <li>your use of ROKiT ID;</li>
        <li>your misuse of connected services;</li>
        <li>your account information or submitted content;</li>
        <li>your violation of these Terms;</li>
        <li>your infringement of third-party rights.</li>
      </ul>

      <h2>17. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of England and Wales, unless
        otherwise required by mandatory local consumer protection laws.
      </p>
      <p>Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

      <h2>18. Changes to These Terms</h2>
      <p>
        We may update these Terms periodically. Where material changes are made, we may provide notice through ROKiT
        ID, connected services, email, or other reasonable methods.
      </p>
      <p>Continued use of ROKiT ID after updates become effective constitutes acceptance of the revised Terms.</p>

      <h2>19. Contact Information</h2>
      <p>For legal notices or support enquiries relating to ROKiT iD, please contact:</p>
      <p>
        <strong>ROKiT Group</strong>
        <br />
        Email: support@rokit.com
      </p>

      <hr />

      <small style={{ display: 'block', textAlign: 'center', marginTop: '1.5rem', color: 'var(--color-text-tertiary)' }}>
        Effective Date: 12 April 2026 | Last Updated: 12 April 2026
      </small>
    </FullWidthStaticLayout>
  );
};

export default TermsPage;